import React from 'react';
import { motion } from 'framer-motion';
interface FloatingDecorProps {
  color?: 'white' | 'dark' | 'pink' | 'orange' | 'yellow' | 'blue';
  count?: number;
  className?: string;
}
export function FloatingDecor({
  color = 'white',
  count = 8,
  className = ''
}: FloatingDecorProps) {
  const colors = {
    white: 'stroke-white/20',
    dark: 'stroke-[#2D2D2D]/10',
    pink: 'stroke-[#FF6B9D]/20',
    orange: 'stroke-[#FF8A3D]/20',
    yellow: 'stroke-[#FFD34D]/30',
    blue: 'stroke-[#BDE1FF]/40'
  };
  const strokeColor = colors[color];
  // Custom thin SVG elements
  const StarBurst = ({
    size
  }: {
    size: number;
  }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={strokeColor} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" data-id="element-79">
      <path d="M12 2v20M2 12h20M4.929 4.929l14.142 14.142M4.929 19.071L19.071 4.929" data-id="element-80" />
    </svg>;
  const Palm = ({
    size
  }: {
    size: number;
  }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={strokeColor} strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" data-id="element-81">
      <path d="M13 8c0-2.76-2.46-5-5.5-5S2 5.24 2 8h2l1-1.5L6 8l1.5-2L9 8h4z" data-id="element-82" />
      <path d="M13 7.14A5.82 5.82 0 0 1 16.5 6c3.04 0 5.5 2.24 5.5 5h-2l-1-1.5-1 1.5-1.5-2-1.5 2h-2v-.86z" data-id="element-83" />
      <path d="M5.8 12c-.81.6-1.8 1-2.8 1-2.21 0-4-1.79-4-4h2l1 1.5L3 9l1.5 2L6 9h1.5l-1.7 3z" data-id="element-84" />
      <path d="M11 22V10" data-id="element-85" />
      <path d="M18.2 12c.81.6 1.8 1 2.8 1 2.21 0 4-1.79 4-4h-2l-1 1.5-1-1.5-1.5 2-1.5-2h-1.5l1.7 3z" data-id="element-86" />
    </svg>;
  const elements = Array.from({
    length: count
  }).map((_, i) => {
    const isStar = Math.random() > 0.3;
    const size = Math.floor(Math.random() * 40) + 20;
    const top = `${Math.floor(Math.random() * 90)}%`;
    const left = `${Math.floor(Math.random() * 90)}%`;
    const duration = Math.random() * 3 + 4; // 4-7s
    const delay = Math.random() * 2;
    return <motion.div key={i} className="absolute pointer-events-none" style={{
      top,
      left
    }} animate={{
      y: [0, -20, 0],
      rotate: [0, 10, -10, 0]
    }} transition={{
      duration,
      delay,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-87">
        {isStar ? <StarBurst size={size} data-id="element-88" /> : <Palm size={size} data-id="element-89" />}
      </motion.div>;
  });
  return <div className={`absolute inset-0 overflow-hidden pointer-events-none z-0 ${className}`} data-id="element-90">
      {elements}
    </div>;
}